module.exports = __webpack_public_path__ + "ecf3b5d0a0cba90271ad0c2db99b8a07.png";